<div class="bank-account-card">
  <div class="d-flex gap-4">
    <div class="d-flex flex-column gap-1 flex-grow-1">
      <div class="d-flex gap-2 align-items-center">
        <div class="bank-account-name">{{ bankAccount.nickname }}</div>
        <app-status-pill *ngIf="bankAccount.inUse && !readOnly" [statusPill]="inUseStatusPill" />
      </div>
      <div
        *ngIf="bankAccount.approvedPreAuthorizedDebit && !readOnly"
        class="d-flex align-items-center"
        [style.gap.rem]="0.375">
        <img
          src="assets/icons/green/CheckCircle.svg"
          height="16"
          width="16"
          alt=""
          [style.height.rem]="1"
          [style.width.rem]="1" />
        <div class="approved" i18n>Approved for withdrawals</div>
      </div>
    </div>
    <div *ngIf="!readOnly" class="desktop-remove-button">
      <ng-container *ngTemplateOutlet="action" />
    </div>
  </div>
  <div class="d-flex flex-column gap-3">
    <div class="bank-info-grid">
      <app-review-entry label="Institution Number" i18n-label [value]="bankAccount.institutionNumber" />
      <app-review-entry label="Transit Number" i18n-label [value]="bankAccount.transitNumber" />
      <app-review-entry label="Account Number" i18n-label [value]="bankAccount.accountNumber" />
    </div>
    <div i18n class="date-added">Date Added: {{ bankAccount.createdDate | date : 'MMMM d, y' }}</div>
  </div>
  <div *ngIf="!readOnly" class="mobile-remove-button">
    <ng-container *ngTemplateOutlet="action" />
  </div>
</div>

<ng-template #action>
  <app-tertiary-button
    *ngIf="bankAccount.inUse; else removeAction"
    [size]="BaseButtonSizeEnum.sm"
    (buttonClicked)="reviewUsageClicked.emit()"
    i18n>
    Review Account Usage
  </app-tertiary-button>
</ng-template>

<ng-template #removeAction>
  <app-tertiary-button
    [leftIconSrc]="'assets/icons/primary/Garbage.svg'"
    [size]="BaseButtonSizeEnum.sm"
    (buttonClicked)="removeAccountClicked.emit()"
    i18n>
    Remove
  </app-tertiary-button>
</ng-template>
